import axios from 'axios'

const APP_ENV = process.env.REACT_APP_ENV
const RESOURCEE_DRIVE = APP_ENV === 'development' ? `https://drive-api-dev.wooblazz.com/v1/files` : `https://drive-api.wooblazz.com/v1/files`
const RESOURCE_URL = `https://resource.looyal.id/crm-wooblazz/`

const CHAT = `${RESOURCE_URL}store-whatsapp-chat-attachments`

export const insertAttachment = async (file: string | File, token: string) => {
    const formData = new FormData()

    formData.append('files', file)
    formData.append('accessor', 'WooBlazz CRM')

    try {
        const response = await axios.post(RESOURCEE_DRIVE, formData, {
            headers: {
                // 'Content-Type': 'multipart/form-data',
                'X-Auth-token': token
            },
        });

        // Mengubah response agar hanya mengembalikan array id dalam "data"
        return {
            data: {
                success: response.data.success,
                message: response.data.message,
                data: response.data.success ? response.data.data.map((file: { id: string, name: string }) => `${RESOURCEE_DRIVE}/${file.id}?view=true&name=/${file.name}`) : [],
            }
        };
    } catch (error: any) {
        console.error("Upload error:", error);
        return {
            data: {
                success: false,
                message: error.message || "Gagal mengunggah berkas.",
                data: []
            },
        };
    }
}

export const insertMultiAttachment = async (files: File[], token: string) => {
    const formData = new FormData();

    files.forEach((file) => {
        formData.append('files', file);
        formData.append('accessor', 'WooBlazz CRM')
    });

    try {
        const response = await axios.post(RESOURCEE_DRIVE, formData, {
            headers: {
                // 'Content-Type': 'multipart/form-data',
                'X-Auth-token': token
            },
        });

        // Mengubah response agar hanya mengembalikan array id dalam "data"
        return {
            data: {
                success: response.data.success,
                message: response.data.message,
                data: response.data.success ? response.data.data.map((file: { id: string, name: string }) => `${RESOURCEE_DRIVE}/${file.id}?view=true&name=/${file.name}`) : [],
            }
        };
    } catch (error: any) {
        console.error("Upload error:", error);
        return {
            data: {
                success: false,
                message: error.message || "Gagal mengunggah berkas.",
                data: []
            },
        };
    }
}

export const insertChatAttachment = async (file: string | File) => {
    const formData = new FormData()

    formData.append('files', file)

    return axios.post(CHAT, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}